exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ssg-timer {\n  display: inline-block; }\n  .ssg-timer .timer-remaining-background {\n    text-align: center;\n    vertical-align: middle;\n    line-height: 50px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/timer-component/timer.scss
// module id = 1274
// module chunks = 0